import { create } from 'zustand';

const useUsageStore = create((set) => ({
    usageParams: { total: 0, limit: 0, percentage: 0 },
    setUsage: (value) => set({ usageParams: {...value} }),
    setClear: () => set({ usageParams: { total: 0, limit: 0, percentage: 0 } }),
}));

export default useUsageStore;